import ValidationException from './ValidationException';

export default class InvalidDateException extends ValidationException {
  constructor(message) {
    super(message);
    this.name = 'InvalidDateException';
  }
}
